export default __webpack_public_path__ + "static/media/ots.912a40a1.svg";